<template>
  <div class="text-center step-wrapper">
    <div class="title font-weight-bold text-h6 mb-2">{{ $t('authLogin.step') }} {{ step }}</div>
    <div class="subtitle font-weight-bold subtitle-2 mt-4 mb-2">{{ subtitle }}</div>
    <div class="description body-1">{{ description }}</div>
  </div>
</template>

<script>
export default {
  name: 'QRStep',
  props: {
    step: {
      type: Number,
      default: () => 0,
    },
    subtitle: {
      type: String,
      default: () => '',
    },
    description: {
      type: String,
      default: () => '',
    },
  },
}
</script>

<style scoped>
.title {
  color: #5757e2;
}

.step-wrapper {
  border: 1px solid #eeeeee;
  box-shadow: 0 3px 3px -2px rgba(188, 188, 188, 0.2);
  border-radius: 16px;
  padding: 32px;
  max-width: 400px;
  margin: 0 auto;
}
</style>
